var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "-72 0 480 480",
    width: "480pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m128 48h80v16h-80zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m120 88h-72v48h72zm-16 32h-40v-16h40zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m136 104h72v16h-72zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m120 152h-72v48h72zm-16 32h-40v-16h40zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m136 168h72v16h-72zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m120 216h-72v48h72zm-16 32h-40v-16h40zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m136 232h72v16h-72zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m120 280h-72v48h72zm-16 32h-40v-16h40zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m136 296h72v16h-72zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m48 344h240v16h-240zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m48 376h56v16h-56zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m128 376h88v16h-88zm0 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m224 104h24v16h-24zm0 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m264 104h24v16h-24zm0 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m224 168h24v16h-24zm0 0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m264 168h24v16h-24zm0 0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m224 232h24v16h-24zm0 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m264 232h24v16h-24zm0 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m224 296h24v16h-24zm0 0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m264 296h24v16h-24zm0 0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m312 0h-288c-13.601562 0-24 10.398438-24 24v432c0 13.601562 10.398438 24 24 24h243.199219l68.800781-76.800781v-379.199219c0-13.601562-10.398438-24-24-24zm8 396.800781-48 53.597657v-34.398438c0-4.800781 3.199219-8 8-8h16v-16h-16c-13.601562 0-24 10.398438-24 24v48h-232c-4.800781 0-8-3.199219-8-8v-432c0-4.800781 3.199219-8 8-8h288c4.800781 0 8 3.199219 8 8zm0 0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/order.82b5bc56.svg";
export { ForwardRef as ReactComponent };